import React from 'react'

function Button2({onClick, name}) {
  return (
    <>
      <button 
      className=' bg-back-color2 hover:bg-white hover:text-primary-color hover:border-primary-color hover:border px-16 py-2.5 border-none rounded-lg text-white'
      onClick={onClick}
      type='submit' 
     >{name}</button>   
    </>
  )
}

export default Button2